import React from 'react';
import { put, call, takeEvery } from 'redux-saga/effects';
import { actions as toastrActions } from 'react-redux-toastr';
import {
    MARK_EXECUTED_PENDING,
    MARK_EXECUTED_FULFILLED,
    CANCEL_RECOVERY_ACTION_PENDING,
    CANCEL_RECOVERY_ACTION_FULFILLED,
    EDIT_TAP_PENDING,
    EDIT_TAP_FULFILLED,
    EDIT_SLIDE_PENDING,
    EDIT_SLIDE_FULFILLED,
} from '../modules/recoveryActions/recoveryActionsDuck';

const pendingToastrOptions = {
    timeOut: 2500,
    icon: <i style={{ margin: 20 }} className="fa fa-spinner fa-pulse fa-2x fa-fw" />,
};

const successToastrOptions = {
    timeOut: 2500,
    icon: 'success',
    removeOnHover: true,
};

export function* showPendingToastr(type) {
    yield put(
        toastrActions.add({
            id: type,
            type: 'info',
            position: 'top-right',
            title: 'Pending...',
            attention: true,
            options: pendingToastrOptions,
        })
    );
}

export function* showSuccessToastr(typesObj) {
    yield put(toastrActions.remove(typesObj.typeP));
    yield put(
        toastrActions.add({
            id: typesObj.typeS,
            type: 'success',
            position: 'top-right',
            title: 'Success!',
            attention: true,
            options: successToastrOptions,
        })
    );
}

export function* showPendingAndSuccessToastrs() {
    // pending
    yield takeEvery(MARK_EXECUTED_PENDING, function*() {
        yield call(showPendingToastr, MARK_EXECUTED_PENDING);
    });
    yield takeEvery(CANCEL_RECOVERY_ACTION_PENDING, function*() {
        yield call(showPendingToastr, CANCEL_RECOVERY_ACTION_PENDING);
    });
    yield takeEvery(EDIT_TAP_PENDING, function*() {
        yield call(showPendingToastr, EDIT_TAP_PENDING);
    });
    yield takeEvery(EDIT_SLIDE_PENDING, function*() {
        yield call(showPendingToastr, EDIT_SLIDE_PENDING);
    });

    // fulfilled
    yield takeEvery(MARK_EXECUTED_FULFILLED, function*() {
        yield call(showSuccessToastr, {
            typeP: MARK_EXECUTED_PENDING,
            typeS: MARK_EXECUTED_FULFILLED,
        });
    });
    yield takeEvery(CANCEL_RECOVERY_ACTION_FULFILLED, function*() {
        yield call(showSuccessToastr, {
            typeP: CANCEL_RECOVERY_ACTION_PENDING,
            typeS: CANCEL_RECOVERY_ACTION_FULFILLED,
        });
    });
    yield takeEvery(EDIT_TAP_FULFILLED, function*() {
        yield call(showSuccessToastr, {
            typeP: CANCEL_RECOVERY_ACTION_PENDING,
            typeS: CANCEL_RECOVERY_ACTION_FULFILLED,
        });
    });
    yield takeEvery(EDIT_SLIDE_FULFILLED, function*() {
        yield call(showSuccessToastr, {
            typeP: EDIT_SLIDE_PENDING,
            typeS: EDIT_SLIDE_FULFILLED,
        });
    });
}
